import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../../../store/actions/alertAction';

const InfoItem = ({
  label,
  value,
  badge,
  variant,
  copyable,
  editable,
  handleEdit,
  clickable,
  handleClick,
  icon,
  iconColor,
  isWebhookUrl,
  isApiKey
}) => {
  const dispatch = useDispatch();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        dispatch(showAlert(`${label} copied to clipboard!`, 'success'));
      })
      .catch((err) => {
        dispatch(showAlert(`Failed to copy ${label} to clipboard!`, 'danger'));
        console.error('Failed to copy: ', err);
      });
  };

  // Special styling for Webhook URL and API Key when they are present
  if ((isWebhookUrl || isApiKey) && value && value !== "Generate" && value !== "View/Manage") {
    return (
      <div className="d-flex flex-column" style={{ gap: '5px' }}>
        <div className="text-secondary" style={{ fontSize: '0.9rem', fontFamily: 'Poppins' }}>
          {label}
        </div>
        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
          <div
            style={{
              fontSize: '0.9rem',
              color: '#344054',
              fontFamily: 'Poppins',
              wordBreak: 'break-all',
              flex: 1
            }}
          >
            {value}
          </div>
          <div className="d-flex align-items-center" style={{ gap: '10px' }}>
            {copyable && (
              <Button
                variant="link"
                size="sm"
                className="p-0"
                onClick={handleCopy}
                style={{ color: '#0BA9E0' }}
              >
                <i className="fas fa-copy" />
              </Button>
            )}
            {editable && (
              <Button
                variant="link"
                size="sm"
                className="p-0"
                onClick={handleEdit}
                style={{ color: '#0BA9E0' }}
              >
                <i className="fas fa-pencil-alt" />
              </Button>
            )}
            {isApiKey && (
              <>
                <Button
                  variant="link"
                  size="sm"
                  className="p-0"
                  onClick={() => handleClick && handleClick('regenerate')}
                  style={{ color: '#0BA9E0' }}
                >
                  <i className="fas fa-sync-alt" />
                </Button>
                <Button
                  variant="link"
                  size="sm"
                  className="p-0"
                  onClick={() => handleClick && handleClick('delete')}
                  style={{ color: '#F76659' }}
                >
                  <i className="fas fa-trash-alt" />
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Default rendering for other items
  return (
    <div className="d-flex flex-column" style={{ gap: '5px' }}>
      <div className="text-secondary" style={{ fontSize: '0.9rem', fontFamily: 'Poppins' }}>
        {label}
      </div>
      <div className="d-flex gap-2 align-items-center">
        {icon && (
          <i
            className={`fas fa-${icon}`}
            style={{ color: iconColor || 'inherit', fontSize: '1rem' }}
          />
        )}
        {badge ? (
          <Badge
            bg={variant}
            className="text-uppercase"
            style={{ fontSize: '0.85rem', padding: '0', minWidth: 'auto', border: 'none' }}
          >
            {value}
          </Badge>
        ) : clickable ? (
          <span
            className="text-primary"
            style={{ fontSize: '0.9rem', cursor: 'pointer' }}
            onClick={() => handleClick()}
          >
            {value}
          </span>
        ) : (
          <span className="text-dark" style={{ fontSize: '0.9rem', fontFamily: 'Poppins' }}>
            {value}
          </span>
        )}
        {copyable && value && (
          <Button variant="link" size="sm" className="p-0 ms-2" onClick={handleCopy}>
            <i className="fas fa-copy" />
          </Button>
        )}
        {editable && (
          <Button variant="link" size="sm" className="p-0 ms-2" onClick={handleEdit}>
            <i className="fas fa-pencil-alt" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default InfoItem;
